<div class="hub-sidebar">
    <button mat-icon-button class="go-back" (click)="close()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="logo">
        <img [src]="logoUrl" alt="">
        <div class="client-title">
            <p>{{ hubName }}</p>
        </div>
    </div>

    <div class="nav-accordion-wrap relative">
        <div top>
            <p>Content</p>
            <div class="relative">
                <ig-accordion #eventAccordion event id="event-type" [disabled]="!isEventEnabled" icon="view_list"
                    title="Events" [class.turnedoff]="!isEventEnabled" (onExpand)="loadLocationFeeds()">
                    <div item class="radio">
                        <mat-radio-group class="radio-group" [(ngModel)]="eventStatusSelection"
                            (ngModelChange)="filterEvents()">
                            <mat-radio-button [value]="'approved'">
                                SHOW APPROVED EVENTS
                            </mat-radio-button>
                            <mat-radio-button [value]="'unapproved'">
                                SHOW UNAPPROVED EVENTS
                            </mat-radio-button>
                            <mat-radio-button [value]="'similar'" (change)="similarEvents()">
                                SHOW SIMILAR EVENTS
                            </mat-radio-button>
                        </mat-radio-group>

                        <div>
                            <mat-checkbox [(ngModel)]="isFilterDateEnabled" (ngModelChange)="filterEvents()">FILTER DATE
                            </mat-checkbox>
                            <div *ngIf="isFilterDateEnabled">
                                <ig-date-field label="From" [(ngModel)]="command.queryParams.from"
                                    [disabled]="!isFilterDateEnabled" [class.enabled]="isFilterDateEnabled"
                                    [class.disabled]="!isFilterDateEnabled" [min]="today" [max]="command.queryParams.to"
                                    (ngModelChange)="filterEvents()">
                                </ig-date-field>
                                <ig-date-field label="To" [(ngModel)]="command.queryParams.to"
                                    [disabled]="!isFilterDateEnabled" [class.enabled]="isFilterDateEnabled"
                                    [class.disabled]="!isFilterDateEnabled" [min]="command.queryParams.from"
                                    (ngModelChange)="filterEvents()">
                                </ig-date-field>
                            </div>
                        </div>

                        <div search>
                            <ig-field igDebounce label="search events"
                                icon="{{searchParam.isSearching?'':searchParam.searchText?'clear':'search'}}"
                                [formControl]="searchFormGroup.get('searchText')" [isInnerLabel]="true"
                                [(ngModel)]="searchParam.searchText" (onIconClick)="clearSearchText('event')"
                                (debounceKeyup)="searchEvents()">
                            </ig-field>
                            <mat-spinner *ngIf="searchParam.isSearching" [diameter]="22"
                                [strokeWidth]="3"></mat-spinner>
                        </div>
                    </div>

                    <ng-container *ngIf="!loadingToggles&&!toggleAndSource.toggle.eventByGeolocation">
                        <div item class="accordion-item-disabled relative">Events by Geolocation
                            <upgrade-button [show]="true" [isSimple]="true"
                                [css]="'upgrade-submitted-event'"></upgrade-button>
                        </div>
                    </ng-container>

                    <ig-accordion *ngIf="isOpenRegionalAccountType" class="second-collapse" title="Events by DMOs"
                        (onExpand)="loadRegionalAccountDMOs()">
                        <div item *ngIf="isLoadingDMOs">
                            <ig-spinner></ig-spinner>
                        </div>
                        <div item *ngIf="!isLoadingDMOs" [ngClass]="{'selected': dmoIsSelected('All')}"
                            (click)="showEventsByDMO()">All
                        </div>
                        <div item *ngFor="let dmo of regionalAccountDMOs" matTooltip="{{dmo}}"
                            [ngClass]="{'selected':dmoIsSelected(dmo)}" (click)="showEventsByDMO(dmo)">
                            {{dmo}}
                        </div>
                    </ig-accordion>

                </ig-accordion>
                <upgrade-button [show]="!loadingToggles&&!isEventEnabled" [css]="'upgrade-event'"></upgrade-button>
            </div>
            <div class="relative">
                <ig-accordion #placeAccordion event id="place-type" [disabled]="!toggleAndSource.toggle.placeCalendar"
                    icon="room" title="Places" (click)="expandPlace($event)"
                    [class.turnedoff]="!toggleAndSource.toggle.placeCalendar">
                    <div item class="radio no-border-bottom">
                        <mat-radio-group class="radio-group" [(ngModel)]="command.queryParams.isApproved"
                            (ngModelChange)="filterPlaces(true)">
                            <mat-radio-button [value]="true">
                                SHOW APPROVED PLACES
                            </mat-radio-button>
                            <mat-radio-button [value]="false">
                                SHOW UNAPPROVED PLACES
                            </mat-radio-button>
                        </mat-radio-group>
                        <mat-radio-button [checked]="command.queryParams.isApproved===undefined"
                            (change)="similarPlaces()">
                            SHOW SIMILAR PLACES
                        </mat-radio-button>

                        <div search>
                            <!--<form ngForm="searchFormGroup" class="relative no-padding">-->
                            <ig-field igDebounce label="search places in all categories"
                                icon="{{searchParam.isSearching?'':searchParam.searchText?'clear':'search'}}"
                                [formControl]="searchFormGroup.get('searchText')" [isInnerLabel]="true"
                                [(ngModel)]="searchParam.searchText" (onIconClick)="clearSearchText('place')"
                                (onFocus)="searchFocus()" (debounceKeyup)="search()"
                                (debounceKeyup)="search()">
                            </ig-field>
                            <mat-checkbox *ngIf="searchParam.isShowSearchPlaceWithNoFilter"
                                class="search-place-with-no-filter" [(ngModel)]="searchParam.isSearchPlaceWithNoFilter"
                                matTooltip="Custom categories may cause some places unable to be displayed. Tick this checkbox to search within all places existing in the database"
                                (ngModelChange)="searchPlacesWithNoFilterChange()">BROAD SEARCH/ACROSS
                                CATEGORIES
                            </mat-checkbox>
                            <!-- <mat-checkbox *ngIf="searchParam.isShowFuzzySearch"
                                class="search-place-with-no-filter" [(ngModel)]="searchParam.isFuzzySearch"
                                matTooltip="Fuzzy Search"
                                (ngModelChange)="fuzzySearchPlaces()">Fuzzy Search
                            </mat-checkbox> -->
                            <mat-spinner *ngIf="searchParam.isSearching" [diameter]="22"
                                [strokeWidth]="3"></mat-spinner>
                            <!--</form>-->
                        </div>
                    </div>

                    <ig-accordion #placeLocationAccordion
                        *ngIf="toggleAndSource.toggle.clientDashboard.placeByGeoLocationTab" class="second-collapse"
                        id="place-by-location" title="Places by Locations" (onExpand)="loadLocationFeeds()">
                        <div item *ngIf="isLoadingFeeds">
                            <ig-spinner></ig-spinner>
                        </div>
                        <div item *ngIf="!isLoadingFeeds" [ngClass]="{'selected': placeCategoryIsSelected('All')}"
                            id="All-places">All
                        </div>
                        <div item *ngFor="let location of facebookLocations" matTooltip="{{location.title}}"
                            [ngClass]="{'selected':feedIsSelected(location.id)}"
                            (click)="showPlacesByFeed(location.id)">
                            {{ location.displayTitle || location.title }}
                        </div>
                    </ig-accordion>

                    <ig-custom-default-place-category-accordion #customDefaultPlaceCategoryAccordion
                        *ngIf="customDefaultPlaceCategory" title="Places by Categories"
                        [toggleAndSource]="toggleAndSource" (onCategoryClick)="selectCustomDefaultPlaceCategory($event)"
                        (onNormalCategoryClick)="showPlace({target: {id: $event}})"
                        [customDefaultPlaceCategory]="customDefaultPlaceCategory"></ig-custom-default-place-category-accordion>
                </ig-accordion>
                <upgrade-button [show]="!loadingToggles&&!toggleAndSource.toggle.placeCalendar"
                    [css]="'upgrade-place'"></upgrade-button>
            </div>

            <ig-accordion #manualAccordion event id="submitted-type" icon="card_giftcard"
                title="Website Form Submissions">
                <div item [class.accordion-item-disabled]="!toggleAndSource.toggle.manualEvents"
                    [ngClass]="{'selected':manualEventsIsSelected('Visitor')}"
                    (click)="toggleAndSource.toggle.manualEvents&&showManualEvents('Visitor')">
                    Website Submitted Events
                    <upgrade-button [show]="!loadingToggles&&!toggleAndSource.toggle.manualEvents" [isSimple]="true"
                        [css]="'upgrade-submitted-event'"></upgrade-button>
                </div>
                <div item [class.accordion-item-disabled]="!toggleAndSource.toggle.placeCalendar"
                    [ngClass]="{'selected':manualPlacesIsSelected('Visitor')}"
                    (click)="toggleAndSource.toggle.placeCalendar&&showManualPlaces('Visitor')">
                    Website Submitted Places
                    <upgrade-button [show]="!loadingToggles&&!toggleAndSource.toggle.placeCalendar" [isSimple]="true"
                        [css]="'upgrade-submitted-event'"></upgrade-button>
                </div>
            </ig-accordion>

        </div>

    </div>

    <div admin class="nav-accordion-wrap relative">
        <div top>
            <p>Admin</p>

            <div tab class="ripple" [class.display-on]="displayingOn===4" (click)="showContentManagementView()">
                <mat-icon>mode_edit</mat-icon>
                <span>Content Management</span>
            </div>
            <div tab class="ripple" [class.display-on]="displayingOn===5" (click)="showCustomizeStyle()">
                <mat-icon>build</mat-icon>
                <span>Customization</span>
            </div>

        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/side.bar/hub.side.bar.component.html